export interface DashboardDateRangeProps {
  from: string;
  to: string;
  onChange: (from: string, to: string) => void;
}

export interface DashboardDateRangeSummaryProps {
  from: string;
  to: string;
}

function utcDate(date: Date): string {
  return date.toISOString().slice(0, 10);
}

export function DashboardDateRange({ from, to, onChange }: DashboardDateRangeProps) {
  const applyDays = (days: number) => {
    const today = new Date();
    const start = new Date(
      Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate() - (days - 1))
    );
    onChange(utcDate(start), utcDate(today));
  };

  return (
    <div className="flex flex-wrap items-center gap-2" aria-label="Dashboard date range">
      {[7, 30, 90].map((days) => (
        <button
          key={days}
          type="button"
          onClick={() => applyDays(days)}
          className="focus-ring rounded-md border border-neutral-200 px-2.5 py-1.5 text-small font-medium text-neutral-700 hover:border-backoffice-300"
        >
          Last {days} days
        </button>
      ))}
      <label className="text-small text-neutral-600">
        From{' '}
        <input
          aria-label="Dashboard date range from"
          type="date"
          value={from}
          max={to}
          onChange={(event) => onChange(event.target.value, to)}
          className="ml-1 rounded-md border border-neutral-200 px-2 py-1"
        />
      </label>
      <label className="text-small text-neutral-600">
        To{' '}
        <input
          aria-label="Dashboard date range to"
          type="date"
          value={to}
          min={from}
          max={utcDate(new Date())}
          onChange={(event) => onChange(from, event.target.value)}
          className="ml-1 rounded-md border border-neutral-200 px-2 py-1"
        />
      </label>
    </div>
  );
}

function formatDate(date: string): string {
  return new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(new Date(`${date}T00:00:00Z`));
}

export function DashboardDateRangeSummary({ from, to }: DashboardDateRangeSummaryProps) {
  return (
    <p className="text-small text-neutral-500" aria-label="Selected dashboard date range">
      Date range: {formatDate(from)} – {formatDate(to)} (UTC)
    </p>
  );
}
